module.exports = __webpack_public_path__ + "static/media/bg-image-40.80eb2b2a.jpg";